import { Button, Col, Flex, Form, Row, Title, message } from 'ui';
import { useAutoFocus } from 'common/hooks';
import { useUser } from 'features/auth';
import { useUpdateNotificationsSettingsMutation } from '../queries';
import {
  BadgeNotificationFormContent,
  type BadgeNotificationFormContentValues,
} from './badge-notification-form-content';
import { useNotificationInitialValues } from './hooks/useNotificationInitialValues';
import { NotificationsFormContent, type NotificationsFormContentValues } from './notifications-form-content';

export type NotificationsFormValues = BadgeNotificationFormContentValues & NotificationsFormContentValues;

const SettingsNotifications = () => {
  const { railsUserData: viewer } = useUser();

  const firstInput = useAutoFocus<HTMLButtonElement>();
  const { isPending: isLoading, mutate: updateNotificationSettings } = useUpdateNotificationsSettingsMutation();

  const onFinish = (data: NotificationsFormValues) => {
    updateNotificationSettings(
      {
        notifications: data,
        userId: viewer.id,
      },
      {
        onSuccess() {
          message.success('Notification settings was successfully updated.');
        },
      },
    );
  };

  const initialValues = useNotificationInitialValues({ viewer });

  return (
    <Flex gap="ms" id="profile-settings-notifications-tab" vertical>
      <Title level={2} marginBottom={false}>
        Notifications
      </Title>
      <Form<NotificationsFormValues> initialValues={initialValues} onFinish={onFinish}>
        <Row>
          <Col span={24}>
            <Row gutter={[0, 'ms']}>
              <Col span={24}>
                <NotificationsFormContent<NotificationsFormValues> firstInput={firstInput} viewer={viewer} />
              </Col>

              <Col span={24}>
                <BadgeNotificationFormContent<NotificationsFormValues> />
              </Col>
            </Row>
          </Col>

          <Col>
            <Button htmlType="submit" loading={isLoading} type="primary">
              Update
            </Button>
          </Col>
        </Row>
      </Form>
    </Flex>
  );
};

export default SettingsNotifications;
